import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from "../../components/loader";

function LedgerReport() {
  const [loader, setLoader] = useState(false);
  const [orderData, setData] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(today);
  const [productData, setProductData] = useState([]);
  const [eDate, setEDate] = useState(today);
  const [sDate, setSDate] = useState(today);
  const [filterdData, setFilteredData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRoutes, setSelectedRoutes] = useState(["all"]);
  const [allRoutes, setAllRoutes] = useState([]);

  // console.log(productData);

  function groupProducts(products) {
    return products.reduce((groups, item) => {
        let groupName = "OTHERS";

        const name = item.productName.toUpperCase();
        const code = item.productCode.toUpperCase();
        const unit = item.unit.toUpperCase();
        const type = item.type.toLowerCase();

        // --- MILK (unit L) ---
        if (unit === "L" && type === "milk") {
            if (code.startsWith("FCM") || name.startsWith("FCM")) groupName = "FCM MILK";
            else if (code.startsWith("SM") || name.startsWith("SM")) groupName = "SM MILK";
            else if (code.startsWith("TM") || name.startsWith("TM")) groupName = "TM MILK";
            else if (code.startsWith("TTM") || name.includes("TEA TIME")) groupName = "TTM MILK";
            else if (code.startsWith("TTM") || name.includes("TEATIME")) groupName = "TTM MILK";
            else groupName = "MILK";
        }

        // --- CURD (unit KG) ---
        else if (unit === "KG" && type === "curd") {
            if (code.startsWith("TMC") || name.startsWith("TMC")) groupName = "TMC CURD";
            else if (code.startsWith("DTMC") || name.startsWith("DTMC")) groupName = "DTMC CURD";
            else if (name.includes("SKIM")) groupName = "SKIM CURD";
            else groupName = "CURD";
        }

        // --- BUTTER MILK ---
        else if (type === "buttermilk") {
            groupName = "BUTTER MILK";
        }

        // --- BUTTER ---
        else if (type === "butter") {
            groupName = "BUTTER";
        }

        // Add to group
        if (!groups[groupName]) groups[groupName] = [];
        groups[groupName].push(item);

        return groups;
    }, {});
}


const groupedProducts = groupProducts(productData);
console.log(groupedProducts);

  const filterDealer = () => {
    const filterData = orderData?.filter((order) => {
      let routeMatch = true;

     

      if (selectedRoutes) {
        if (typeof selectedRoutes === "string") {
          routeMatch = order?.routes
            ?.toLowerCase()
            .includes(selectedRoutes.toLowerCase());
        } else if (Array.isArray(selectedRoutes)) {
          if (selectedRoutes.includes("all")) {
            routeMatch = true;
          } else if (selectedRoutes.length > 0) {
            routeMatch = selectedRoutes.some((route) =>
              order?.routeName?.toLowerCase().includes(route.toLowerCase())
            );
          } else {
            routeMatch = false;
          }
        }
      }

      return routeMatch;
    });

    // console.log(filterData);
    setFilteredData(filterData);
  };

  useEffect(() => {
    filterDealer();
  }, [selectedRoutes]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleRouteSelection = (route) => {
    if (route === "all") {
      if (selectedRoutes.includes("all")) {
        setSelectedRoutes([]);
      } else {
        setSelectedRoutes(["all"]);
      }
    } else {
      if (selectedRoutes.includes(route)) {
        const updatedRoutes = selectedRoutes.filter((r) => r !== route);
        if (updatedRoutes.length === 0) {
          setSelectedRoutes(["all"]);
          filterDealer();
        } else {
          setSelectedRoutes(updatedRoutes.filter((r) => r !== "all"));
          filterDealer();
        }
      } else {
        const updatedRoutes = [
          ...selectedRoutes.filter((r) => r !== "all"),
          route,
        ];
        setSelectedRoutes(updatedRoutes);
        filterDealer();
      }
    }
  };

  const isRouteSelected = (route) => {
    return selectedRoutes.includes("all") || selectedRoutes.includes(route);
  };

  const formatDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      console.error("Invalid date format");
      return;
    }

    const formattedDate = `${newDate.getFullYear()}-${String(
      newDate.getMonth() + 1
    ).padStart(2, "0")}-${String(newDate.getDate()).padStart(2, "0")}`;
    return formattedDate;
  };

  const formatViewDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      console.error("Invalid date format");
      return;
    }

    const formattedDate = `${String(newDate.getDate()).padStart(
      2,
      "0"
    )}-${String(newDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${newDate.getFullYear()}`;
    return formattedDate;
  };

  const formatSendDate = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const getData = async () => {
    setLoader(true);
    const sendData = {
      sDate: formatSendDate(sDate),
      eDate: formatSendDate(eDate),
    };

    try {
      const response = await axios.post(
        "https://api.trucoo.in/invoice/monthly-report/",
        sendData,
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );

      //console.log(response.data);

      if (response.data.status === "success") {
        setData(response.data.data);
        setFilteredData(response.data.data);
        const routes = [
          ...new Set(
            response.data.data
              .map((order) => order.routeName || "")
              .filter((r) => r)
          ),
        ];

        setAllRoutes(routes);
      } else {
        // console.log("Error fetching data");
        setData([]);
      }
    } catch (error) {
      console.error("Error:", error.response || error.message);
      setData([]);
    }
    setLoader(false);
  };

  const getProducts = async () => {
    try {
      const response = await axios.post(
        "https://api.trucoo.in/products/all-product/",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );

      if (response.data.status === "success") {
        setProductData(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error.response || error.message);
    }
  };

  useEffect(() => {
    getProducts();
    getData();
  }, [date]);

  const getFiscalYearLabel = (date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    if (month < 3) {
      return `${(year - 1).toString().slice(-2)}-${year.toString().slice(-2)}`;
    } else {
      return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
    }
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("printableArea")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Daily Sales Report");
    XLSX.writeFile(wb, `Daily_Sales_Report_${formatDate(date)}.xlsx`);
  };

  const getItemDetails = (orderData, item) => {
    const itemData = orderData?.filter((items) => items.itemId === item)[0];
    // console.log(itemData);

    if (itemData) {
      const weight =
        parseFloat(itemData?.qty) *
        parseFloat(itemData?.itemGrade) *
        parseFloat(itemData?.itemWeight / 1000);
      const qty = parseFloat(itemData?.qty) * parseFloat(itemData?.itemGrade);
      const crates = parseFloat(itemData?.qty);
      const amount =
        parseFloat(itemData?.qty) *
        parseFloat(itemData?.itemGrade) *
        parseFloat(itemData?.itemPrice);

      const rData = { weight, qty, crates, amount };

      return rData;
    } else {
      return null;
    }
  };

  const productStates = {};

  productData?.forEach((product) => {
    productStates[`Crates${product?.id}`] = 0;
    productStates[`Qty${product?.id}`] = 0;
    productStates[`Weight${product?.id}`] = 0;
    productStates[`Amount${product?.id}`] = 0;
  });


  const groupedData = filterdData?.reduce((acc, item) => {
    if (!acc[item.routeName]) {
      acc[item.routeName] = [];
    }
    acc[item.routeName].push(item);
    return acc;
  }, {});


  const getGroupedItemDetails = (orderData, productIds) => {
    // productIds can be single ID or array
    const idList = Array.isArray(productIds) ? productIds : [productIds];

    // Filter all matched products inside the group
    const matched = orderData?.filter((item) =>
      idList.includes(item.itemId)
    );

    if (!matched || matched.length === 0) return null;

    // Sum totals for all products in that group
    return matched.reduce(
      (sum, itemData) => {
        const weight =
          parseFloat(itemData.qty) *
          parseFloat(itemData.itemGrade) *
          parseFloat(itemData.itemWeight / 1000);

        const qty = parseFloat(itemData.qty) * parseFloat(itemData.itemGrade);
        const crates = parseFloat(itemData.qty);
        const amount =
          parseFloat(itemData.qty) *
          parseFloat(itemData.itemGrade) *
          parseFloat(itemData.itemPrice);

        sum.weight += weight;
        sum.qty += qty;
        sum.crates += crates;
        sum.amount += amount;

        return sum;
      },
      { weight: 0, qty: 0, crates: 0, amount: 0 }
    );
  };


  return (
    <>
      {loader && <Loader />}
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <div className="row">
                  <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12">
                    <h4 className="box-title">Route Reports</h4>
                    <p className="mb-0 box-subtitle">Items</p>
                  </div>
                  <div className="row justify-content-end align-items-center">
                    
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12 mb-2">
                      <div className="input-group">
                        <input
                          type="date"
                          value={formatDate(sDate)}
                          onChange={(e) => setSDate(e.target.value)}
                          className="form-control"
                        />
                        <input
                          type="date"
                          value={formatDate(eDate)}
                          onChange={(e) => setEDate(e.target.value)}
                          className="form-control"
                        />
                        <button
                          className="btn btn-sm btn-success"
                          onClick={getData}
                        >
                          Get Report
                        </button>
                      </div>
                    </div>

                    <div className="col-md-2 mb-2">
                      <div className="dropdown">
                        <button
                          className="form-control text-start"
                          onClick={toggleDropdown}
                          style={{ textAlign: "left" }}
                        >
                          {selectedRoutes.includes("all")
                            ? "All Routes"
                            : `${selectedRoutes.length} Routes Selected`}
                        </button>
                        {isOpen && (
                          <div
                            className="dropdown-menu show"
                            style={{ minWidth: "250px", padding: "8px", overflowX: 'scroll', maxHeight: '69vh'}}
                          >
                            <div className="mb-2 d-flex justify-content-between align-items-center border-bottom pb-2">
                              <strong>Select Routes</strong>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={toggleDropdown}
                              >
                                ×
                              </button>
                            </div>

                            <div className="dropdown-item py-1">
                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{
                                    opacity: 0,
                                    position: "absolute",
                                    left: "10px",
                                  }}
                                  id="allRoutesCheckbox"
                                  value="all"
                                  checked={selectedRoutes.includes("all")}
                                  onChange={() => handleRouteSelection("all")}
                                />
                                <label
                                  className="form-check-label ms-3"
                                  htmlFor="allRoutesCheckbox"
                                  style={{ paddingLeft: "24px" }}
                                >
                                  All Routes
                                </label>
                              </div>
                            </div>

                            {allRoutes.map((route) => (
                              <div key={route} className="dropdown-item py-1">
                                <div className="form-check d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{
                                      opacity: 0,
                                      position: "absolute",
                                      left: "10px",
                                    }}
                                    id={`routeCheckbox-${route}`}
                                    value={route}
                                    checked={isRouteSelected(route)}
                                    onChange={() => handleRouteSelection(route)}
                                  />
                                  <label
                                    className="form-check-label ms-3"
                                    htmlFor={`routeCheckbox-${route}`}
                                    style={{ paddingLeft: "24px" }}
                                  >
                                    {route}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-auto mb-2">
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={exportToExcel}
                      >
                        <i className="fa fa-download"></i> Excel
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-body">
                <div
                  className="table-responsive"
                  style={{
                    width: "100%",
                    height: "60vh",
                    overflow: "auto",
                    padding: "0 10px 10px 10px",
                  }}
                >
                  <table
                    style={{ whiteSpace: "nowrap" }}
                    className="table-sm table-bordered nowrap fs-10"
                    id="printableArea"
                    width="100%"
                  >
                    <thead>
                      <tr
                        className="text-dark text-center"
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                      
                        
                        <th rowspan="2" className="border-r">
                          Routes
                        </th>
                        {Object.entries(groupedProducts).map(([groupName, items]) => (
                          <th colSpan={4} key={groupName} className="border-r">
                            {groupName}
                          </th>
                        ))}
                      </tr>
                      <tr
                        className="text-dark text-center"
                        style={{
                          position: "sticky",
                          top: "25px",
                          zIndex: 1,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        {Object.entries(groupedProducts).map(([groupName, items]) => (
                          <>
                            <th>CRT</th>
                            <th>PKT</th>
                            <th>LTR/KG</th>
                            <th className="border-r">AMOUNT</th>
                          </>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filterdData?.length > 0 ? (
                        <>
                          {Object.entries(groupedData).map(([routeName, items]) => {
                            return (
                              <React.Fragment key={routeName}>
                                {/* Group Total Row */}
                                <tr className="">
                                  <td className="border-r">
                                    {routeName}
                                  </td>
                                  {Object.entries(groupedProducts).map(([groupName, products]) => {

                                    // Extract all product IDs from group
                                    const productIds = products.map((p) => p.id);

                                    const totals = items.reduce(
                                      (sum, d) => {
                                        const details = getGroupedItemDetails(d.orderData, productIds);

                                        sum.crates += Number(details?.crates || 0);
                                        sum.qty += Number(details?.qty || 0);
                                        sum.weight += Number(details?.weight || 0);
                                        sum.amount += Number(details?.amount || 0);

                                        return sum;
                                      },
                                      { crates: 0, qty: 0, weight: 0, amount: 0 }
                                    );

                                    return (
                                      <React.Fragment key={groupName}>

                                          <td className="text-end">
                                            {totals.crates > 0 && totals.crates.toFixed(2)}
                                          </td>
                                          <td className="text-end">
                                            {totals.qty > 0 && totals.qty.toFixed(2)}
                                          </td>
                                          <td className="text-end">
                                            {totals.weight > 0 && totals.weight.toFixed(2)}
                                          </td>
                                          <td className="text-end border-r">
                                            {totals.amount > 0 && totals.amount.toFixed(2)}
                                          </td>
                                      </React.Fragment>
                                    );
                                  })}

                                </tr>
                              </React.Fragment>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="17" className="text-center">
                            No Data Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
}

export default LedgerReport;
